module.exports = __webpack_public_path__ + "static/media/shahi.e195c31c.jpg";